// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as WalletTransactionsReportViewMapper from "../../vm-mapper/wallet-list/WalletTransactionsReportViewMapper.bs.js";

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetFilters */0 :
        return {
                report: {
                  TAG: /* Loading */0,
                  _0: undefined
                },
                filters: action._0,
                showCreateTransactionModal: state.showCreateTransactionModal,
                createTransactionStatus: state.createTransactionStatus
              };
    case /* SetWalletReport */1 :
        return {
                report: action._0,
                filters: state.filters,
                showCreateTransactionModal: state.showCreateTransactionModal,
                createTransactionStatus: state.createTransactionStatus
              };
    case /* SetCreateTransactionStatus */2 :
        return {
                report: state.report,
                filters: state.filters,
                showCreateTransactionModal: state.showCreateTransactionModal,
                createTransactionStatus: action._0
              };
    case /* SetWalletReportError */3 :
        return {
                report: {
                  TAG: /* Error */2,
                  _0: action._0
                },
                filters: state.filters,
                showCreateTransactionModal: state.showCreateTransactionModal,
                createTransactionStatus: state.createTransactionStatus
              };
    case /* SetCreateTransactionModal */4 :
        return {
                report: state.report,
                filters: state.filters,
                showCreateTransactionModal: action._0,
                createTransactionStatus: /* Init */0
              };
    
  }
}

function WalletTransactionsReportComponent(Props) {
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var initialState_filters = {
    tillDate: new Date(),
    transactionStatus: undefined
  };
  var initialState = {
    report: /* Init */0,
    filters: initialState_filters,
    showCreateTransactionModal: false,
    createTransactionStatus: /* Init */0
  };
  var match$1 = React.useReducer(reducer, initialState);
  var dispatch = match$1[1];
  var state = match$1[0];
  var getTransactionsOffset = function (param) {
    var report = state.report;
    if (typeof report === "number") {
      return ;
    }
    switch (report.TAG | 0) {
      case /* Loading */0 :
          var report$1 = report._0;
          if (report$1 !== undefined) {
            return report$1.offset;
          } else {
            return ;
          }
      case /* Live */1 :
          return report._0.offset;
      case /* Error */2 :
          return ;
      
    }
  };
  var fetchExistingWalletTransactions = function (param) {
    var match = state.report;
    if (typeof match === "number") {
      return /* [] */0;
    }
    switch (match.TAG | 0) {
      case /* Loading */0 :
          var prevReport = match._0;
          if (prevReport !== undefined) {
            return prevReport.transactions;
          } else {
            return /* [] */0;
          }
      case /* Live */1 :
          return match._0.transactions;
      case /* Error */2 :
          return /* [] */0;
      
    }
  };
  var fetchWalletTransactions = function (param) {
    var RepoInstance = CrmRepoManager.getWalletRepo(undefined);
    var walletReportRequest_tillDate = state.filters.tillDate;
    var walletReportRequest_transactionStatus = state.filters.transactionStatus;
    var walletReportRequest_offset = getTransactionsOffset(undefined);
    var walletReportRequest = {
      msisdn: msisdn,
      tillDate: walletReportRequest_tillDate,
      transactionStatus: walletReportRequest_transactionStatus,
      offset: walletReportRequest_offset
    };
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(RepoInstance.fetchWallet, walletReportRequest, country);
                }), (function (data) {
                  return Curry._1(dispatch, {
                              TAG: /* SetWalletReport */1,
                              _0: {
                                TAG: /* Live */1,
                                _0: {
                                  balanceAmount: data.balanceAmount,
                                  walletVersionId: data.walletVersionId,
                                  transactions: Pervasives.$at(fetchExistingWalletTransactions(undefined), data.transactions),
                                  offset: data.offset,
                                  endOfTransactionResults: List.length(data.transactions) === 0
                                }
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetWalletReportError */3,
                              _0: error
                            });
                }));
  };
  React.useEffect((function () {
          fetchWalletTransactions(undefined);
          
        }), []);
  React.useEffect((function () {
          var _data = state.report;
          if (typeof _data !== "number" && _data.TAG === /* Loading */0) {
            fetchWalletTransactions(undefined);
          }
          
        }), [state.report]);
  var onScrollEndCallback = function (param) {
    var report = state.report;
    if (typeof report === "number" || !(report.TAG === /* Live */1 && !report._0.endOfTransactionResults)) {
      return ;
    } else {
      var match = state.report;
      if (typeof match === "number") {
        return Curry._1(dispatch, {
                    TAG: /* SetWalletReport */1,
                    _0: {
                      TAG: /* Loading */0,
                      _0: undefined
                    }
                  });
      }
      switch (match.TAG | 0) {
        case /* Loading */0 :
            var report$1 = match._0;
            if (report$1 !== undefined) {
              return Curry._1(dispatch, {
                          TAG: /* SetWalletReport */1,
                          _0: {
                            TAG: /* Loading */0,
                            _0: report$1
                          }
                        });
            } else {
              return Curry._1(dispatch, {
                          TAG: /* SetWalletReport */1,
                          _0: {
                            TAG: /* Loading */0,
                            _0: undefined
                          }
                        });
            }
        case /* Live */1 :
            return Curry._1(dispatch, {
                        TAG: /* SetWalletReport */1,
                        _0: {
                          TAG: /* Loading */0,
                          _0: match._0
                        }
                      });
        case /* Error */2 :
            return Curry._1(dispatch, {
                        TAG: /* SetWalletReport */1,
                        _0: {
                          TAG: /* Loading */0,
                          _0: undefined
                        }
                      });
        
      }
    }
  };
  var fetchWalletVersionId = function (param) {
    var report = state.report;
    if (typeof report === "number") {
      return ErrorUtils$Catalyst.raiseError("WalletTransactionsReportComponent.re", "Invalid wallet report ", "");
    }
    switch (report.TAG | 0) {
      case /* Loading */0 :
          var report$1 = report._0;
          if (report$1 !== undefined) {
            return report$1.walletVersionId;
          } else {
            return ErrorUtils$Catalyst.raiseError("WalletTransactionsReportComponent.re", "Invalid wallet report ", "");
          }
      case /* Live */1 :
          return report._0.walletVersionId;
      case /* Error */2 :
          return ErrorUtils$Catalyst.raiseError("WalletTransactionsReportComponent.re", "Invalid wallet report ", "");
      
    }
  };
  var openCreateTransactionModal = function (param) {
    return Curry._1(dispatch, {
                TAG: /* SetCreateTransactionModal */4,
                _0: true
              });
  };
  var closeCreateTransactionModal = function (param) {
    return Curry._1(dispatch, {
                TAG: /* SetCreateTransactionModal */4,
                _0: false
              });
  };
  var createAdminTransaction = function (formData) {
    var RepoInstance = CrmRepoManager.getWalletRepo(undefined);
    var txnType = formData.transactionType;
    var $$float = formData.amount;
    var reason = formData.transactionReason;
    var request_transactionType = txnType !== undefined ? txnType : ErrorUtils$Catalyst.raiseError("WalletTransactionsReportComponent.re", "transactionType doesn't exist", "");
    var request_amount = $$float !== undefined ? $$float : ErrorUtils$Catalyst.raiseError("WalletTransactionsReportComponent.re", "formData.amount doesn't exist", "");
    var request_reason = reason !== undefined ? reason.id : ErrorUtils$Catalyst.raiseError("WalletTransactionsReportComponent.re", "transactionReason doesn't exist", "");
    var request_admin_comment = formData.admin_comment;
    var request_partner_comment = formData.partner_comment;
    var request_walletVersionId = fetchWalletVersionId(undefined);
    var request = {
      transactionType: request_transactionType,
      amount: request_amount,
      reason: request_reason,
      admin_comment: request_admin_comment,
      partner_comment: request_partner_comment,
      walletVersionId: request_walletVersionId
    };
    Curry._1(dispatch, {
          TAG: /* SetCreateTransactionStatus */2,
          _0: {
            TAG: /* Loading */0,
            _0: undefined
          }
        });
    return Curry._3(RepoInstance.createTransaction, msisdn, request, country).then(function (result) {
                if (result.TAG === /* Ok */0) {
                  Curry._1(dispatch, {
                        TAG: /* SetCreateTransactionStatus */2,
                        _0: /* Init */0
                      });
                } else {
                  Curry._1(dispatch, {
                        TAG: /* SetCreateTransactionStatus */2,
                        _0: {
                          TAG: /* Error */2,
                          _0: result._0
                        }
                      });
                }
                return Promise.resolve(result);
              });
  };
  return WalletTransactionsReportViewMapper.getView(state, onScrollEndCallback, (function (filters) {
                return Curry._1(dispatch, {
                            TAG: /* SetFilters */0,
                            _0: filters
                          });
              }), createAdminTransaction, openCreateTransactionModal, closeCreateTransactionModal, (function (param) {
                return Curry._1(dispatch, {
                            TAG: /* SetFilters */0,
                            _0: state.filters
                          });
              }));
}

var make = WalletTransactionsReportComponent;

export {
  reducer ,
  make ,
  
}
/* react Not a pure module */
